import intlTelInput from "intl-tel-input";
import { attachPhoneFormat, PHONE_UTILS } from "../basics/phoneField";

const Register = {
    data() {
        return {
            iti: null,
            phoneErrorCode: 0,
            hasPhoneError: false,
            firstName: "",
            lastName: "",
            email: "",
            phone: "",
            termsAndPolicy: false,
            termsAcceptedAt: "",
            privacyPolicyAcceptedAt: "",
            firstNameError: "",
            lastNameError: "",
            emailError: "",
            phoneError: "",
            termsAndPolicyError: false,
            termsAcceptedAtError: "",
            privacyPolicyAcceptedAtError: "",

            needChallenge: false,
            captchaID1: null,
        };
    },
    mounted() {
        // the login form sends here an email that has no account yet
        const handoff = authHandoff.take();
        if (handoff?.email && !this.email) {
            this.email = handoff.email;
        }

        const phoneInput = document.querySelector("#phone");
        if (!phoneInput) {
            return;
        }

        this.iti = intlTelInput(phoneInput, {
            separateDialCode: true,
            initialCountry: typeof user_country === "string" ? user_country.toLowerCase() : "hu",
            utilsScript: PHONE_UTILS,
        });
        attachPhoneFormat(this.iti, phoneInput);
    },
    methods: {
        callStartLogin() {

            let phone = this.phone;
            if (this.iti != null) {
                this.phoneErrorCode = 0;
                this.hasPhoneError = false;
                phone = this.iti.getNumber();
                if(!this.iti.isValidNumber()){
                    this.phoneErrorCode = this.iti.getValidationError();
                    if(this.phoneErrorCode !== 4 && this.phoneErrorCode !== 0) {
                        this.hasPhoneError = true;
                    }
                }
            }

            if(this.hasPhoneError){
                return;
            }

            let bodyContent = {
                first_name: this.firstName,
                last_name: this.lastName,
                email: this.email,
                phone: phone,
                terms_accepted_at: this.termsAcceptedAt,
                privacy_policy_accepted_at: this.privacyPolicyAcceptedAt,
            };
            if (this.needChallenge) {
                bodyContent.h_captcha_response = hcaptcha.getResponse(this.captchaID1);
            }
            http.postJson("/api/register/start", bodyContent)
                .then((response) => response.json())
                .then((data) => {
                    if (data?.code == 200) {
                        const pinToken = data.data?.["customer-pin-token"];
                        if (pinToken) {
                            // the email already has an account: the core sent a login code
                            // instead of creating one -> the login page opens on the PIN step
                            authHandoff.set({email: this.email, token: pinToken});
                        } else {
                            localStorage.setItem("registerSuccess", true);
                            authHandoff.set({email: this.email});
                            let name = data.data.fullname;
                            if (!name) name = data.data.crmItemContact?.name;
                            AppEvents.callEvent("COMPLETE_REGISTRATION", {content_name: name ?? "", currency: currency});
                        }
                        window.location.pathname = (window.SHOP_BASE || "") + "/login";
                    }else if (data["need-challenge"]){
                        let _this = this;
                        window.loadCaptcha(() => {
                            if (this.needChallenge) {
                                hcaptcha.reset(this.captchaID1);
                            } else {
                                _this.needChallenge = data["need-challenge"];
                                _this.captchaID1 = hcaptcha.render(_this.$refs.captcha1, {
                                    sitekey: process.env.MIX_HCAPTCHA_TOKEN,
                                });
                            }
                        });
                    } else if (data.errors){
                        if (data.errors["email"])
                            this.emailError = data.errors["email"][0];
                        if (data.errors["first_name"])
                            this.firstNameError = data.errors["first_name"][0];
                        if (data.errors["last_name"])
                            this.lastNameError = data.errors["last_name"][0];
                        if (data.errors["phone"])
                            this.phoneError = data.errors["phone"][0];
                        if (data.errors["terms_accepted_at"])
                            this.termsAcceptedAtError = data.errors["terms_accepted_at"][0];
                        if (data.errors["privacy_policy_accepted_at"])
                            this.privacyPolicyAcceptedAtError = data.errors["privacy_policy_accepted_at"][0];
                    } else {
                        this.emailError = data.message || "Error";
                    }
                })
                .catch((error) => {
                    console.log("error", error);
                });
        },
    },
    watch: {
        termsAndPolicy(value) {
            if (value) {
                let date = new Date().toISOString().split("T")[0];
                this.termsAcceptedAt = date;
                this.privacyPolicyAcceptedAt = date;
            } else {
                this.termsAcceptedAt = "";
                this.privacyPolicyAcceptedAt = "";
            }
        },
    },
};

// Global register object
const REGISTER = {
    vue: null,
    loaded: false,
    load() {
        if (this.loaded) {
            return;
        }
        if (document.getElementById("register") !== undefined && document.getElementById("register") !== null) {
            this.loaded = true;
            this.loadIntlTelInputCSS();
            this.vue = Vue.createApp(Register).mount("#register");
            forms.load();
        }
    },
    loadIntlTelInputCSS() {
        setTimeout(() => {
            if (document.querySelector('link[href*="intlTelInput.css"]')) return;
            const link = document.createElement("link");
            link.rel = "stylesheet";
            link.href = "https://cdn.jsdelivr.net/npm/intl-tel-input@18.2.1/build/css/intlTelInput.css";
            document.head.appendChild(link);
        },0);
    },
};
window.REGISTER = REGISTER;

window.addEventListener("DOMContentLoaded", () => {
    setTimeout(() => {
        REGISTER.load();
    },0);
});

if (document.readyState !== "loading") {
    setTimeout(() => {
        REGISTER.load();
    },0);
}
